import { render, staticRenderFns } from "./settlementDialog.vue?vue&type=template&id=5b7cabe3&scoped=true&"
import script from "./settlementDialog.vue?vue&type=script&lang=js&"
export * from "./settlementDialog.vue?vue&type=script&lang=js&"
import style0 from "./settlementDialog.vue?vue&type=style&index=0&id=5b7cabe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7cabe3",
  null
  
)

export default component.exports